import { render, staticRenderFns } from "./world-compliance.html?vue&type=template&id=6ead34d8&scoped=true&"
import script from "./world-compliance.js?vue&type=script&lang=js&"
export * from "./world-compliance.js?vue&type=script&lang=js&"
import style0 from "./world-compliance.scss?vue&type=style&index=0&id=6ead34d8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ead34d8",
  null
  
)

export default component.exports